import { useEffect, useState } from "react";
import { Form, Button, Modal, Drawer } from "antd";
import { gql, useMutation, useLazyQuery } from "@apollo/client";
import ContractTemplateEditor from "@general/contractTemplateEditor";
import WorkSpaceInputs from "../inputs/workSpace";
const CRERATEPRODUCT = gql`
  mutation CreateWorkSpace($createWorkSpaceInput: CreateWorkSpaceInput!) {
    createWorkSpace(createWorkSpaceInput: $createWorkSpaceInput) {
      id
      name
      contract
    }
  }
`;
const GETWPCONTRACTVARIABLES = gql`
  query {
    getProductContractVariable {
      name
      title
    }
  }
`;

function AddWorkSpace() {
  const [error, setError] = useState(null);
  const [workSpaceContractDrawer, setWorkSpaceDrawer] = useState(false);
  const [workSpaceContract, setWorkSpaceContract] = useState("<html></html>");
  const [wpContractVariables, setWpContractVariable] = useState();

  const [form] = Form.useForm();
  const [getContractVariables, contrcatVariables] = useLazyQuery(
    GETWPCONTRACTVARIABLES,
    {
      onCompleted({ getProductContractVariable }) {
        setWpContractVariable(getProductContractVariable);
      },
      onError(e) {
        console.log("error: " + e.message);
      },
    }
  );
  const [runCreateProduct, createProduct] = useMutation(CRERATEPRODUCT, {
    onCompleted({ createWorkSpace }) {
      Modal.success({
        content: `${createWorkSpace?.name} به خدمات صفاتک اضافه شد.`,
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
        onOk: () => form.resetFields(),
      });
      setWorkSpaceContract(createWorkSpace?.contract);
    },
    onError(err) {
      console.log("خطا: " + err.message);
      Modal.error({
        title: "مشکلی پیش آمده!",
        content: "لطفا دوباره تلاش کنید!",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    },
  });
  useEffect(() => {
    getContractVariables();
  }, []);
  const doCreateProduct = (createWorkSpaceInput) => {
    runCreateProduct({
      variables: {
        createWorkSpaceInput: {
          ...createWorkSpaceInput,
          contract: workSpaceContract,
        },
      },
    });
  };

  return (
    <>
      <Drawer
        title={"تعهدنامه استفاده از فضای کار"}
        placement="top"
        open={workSpaceContractDrawer}
        onClose={() => setWorkSpaceDrawer(false)}
        height={550}
      >
        <ContractTemplateEditor
          contract={workSpaceContract}
          onCloseDrawer={() => setWorkSpaceDrawer(false)}
          onEditContract={(newContract) => setWorkSpaceContract(newContract)}
          helpVars={wpContractVariables}
        />
      </Drawer>
      <Form layout="vertical" onFinish={doCreateProduct} form={form}>
        <WorkSpaceInputs
          error={error}
          onSetWorkSpaceDrawer={setWorkSpaceDrawer}
        />
        <Button
          type="primary"
          htmlType="submit"
          loading={createProduct.loading && true}
        >
          ثبت خدمت
        </Button>
      </Form>
    </>
  );
}

export default AddWorkSpace;
